// Include the Google Font Raleway
//require('typeface-raleway')


require('sharer.js')
require('isotope-layout/dist/isotope.pkgd.min')
// Include local SVG Icons
require('./atol-icons.font')

require('bootstrap-sass')

require('./components/menu-mobile')

/*INCLUDE FANCYBOX*/
require('@fancyapps/fancybox/dist/jquery.fancybox.css');
require('@fancyapps/fancybox');


var imagesLoaded = require('imagesloaded');

// provide jQuery argument
imagesLoaded.makeJQueryPlugin( $ );



require('./components/scroll-to')

import {UrlParam} from './includes/utils'

// require('bootstrap-select/dist/css/bootstrap-select.min.css');
// require('bootstrap-select');


if($('.b1').length > 0) {
    require('./components/5-raisons')
}

$( document ).ready(function() {
    if ($('.dotScroll').length > 0) {
        require('malihu-custom-scrollbar-plugin')
        $('.dotScroll').mCustomScrollbar({
            axis:"y",
            theme: "rounded-dots-dark"
        });
    }


    // $('#form-postuler').click(function() {
    //
    //     let url = '/offres-emplois/postuler';
    //
    //     if($(this).attr('jobid')) {
    //         url += '?jobid=' + $(this).attr('jobid');
    //     }
    //
    //     Drupal.ajax({
    //         url: url,
    //         success: function(response) {
    //
    //
    //             $.fancybox.open({
    //                 type: 'html',
    //                 src  : response[3].data,
    //             });
    //         }
    //     }).execute();
    // })


})

if($('#map').length > 0) {
    require('./components/map')
}

if($('.social-title').length > 0){
    require('./components/socialwall')
}

if($('.popin').length > 0){
    require('./components/popin')
}

if($('.blur').length > 0) {
    require('./components/blur')
}

if($('.owl-carousel').length > 0) {
    require('./components/owl-carousel')
}


if($('[data-load-more-target]').length > 0) {
    require('./components/load-more')
}








if($('#webform-submission-ouvrir-un-magasin-node-108-add-form').length > 0){
    let region = {
        "auvergne-rhone-alpes":"Auvergne-Rhône-Alpes",
        "bourgogne-franche-comte":"Bourgogne-Franche-Comté",
        "bretagne":"Bretagne",
        "centre-val-de-loire":"Centre-Val de Loire",
        "corse":"Corse",
        "grand-est":"Grand Est",
        "hauts-de-france":"Hauts-de-France",
        "ile-de-france":"Île-de-France",
        "normandie":"Normandie",
        "nouvelle-aquitaine":"Nouvelle-Aquitaine",
        "occitanie":"Occitanie",
        "pays-de-la-loire":"Pays de la Loire",
        "provence-alpes-cote-dazur":"Provence-Alpes-Côte d'Azur",
    };
    let fill_projet = UrlParam('fill-votre-projet');
    let fill_region = region[UrlParam('fill-votre-region')];
    let fill_ville = UrlParam('fill-votre-ville');
    if(fill_projet != null){
        $('#edit-votre-projet').val(decodeURI(fill_projet));
    }
    if(fill_region != null){
        $('#edit-location').val(decodeURI(fill_region));
    }
    if(fill_ville != null){
        $('#edit-location').val(decodeURI(fill_ville));
    }
}


if($('.new-img').length > 0){
    $('.new-img').click(function(){
        var href = $(this).closest('.news-item').find('.news-title a').attr('href');
        if(href) {
            document.location.href = href;
        }
    });
}

let sticky = $('#navbar');

if($(window).scrollTop() > 50){
    sticky.addClass('sticky');
}
$(window).scroll(function(){
    let scroll = $(window).scrollTop();
    if (scroll > 50)
    {
        sticky.addClass('sticky');
    } else{
        sticky.removeClass('sticky');
    }
});


// let selectpicker = $('.selectpicker select');
// if(selectpicker.length > 0){
//     selectpicker.selectpicker();
// }






if($(".rejoignez-atol .js-form-file").length > 0){
    var $className = 'js-form-file';
    var selectors = $('.'+$className);
    var ifile = 1;
    selectors.each(function(){
        let inputfileHTML = '' +
        '   <div data-input-index="'+ifile+'" class="styled-input-file sif-'+ifile+'">' +
        '       <span class="text">Piéce jointe</span>' +
        '       <span class="icon">' +
        '       <i class="fas fa-arrow-down"></i>' +
        '       </span>' +
        '   </div>';
        $(this).attr('data-input-index', ifile).addClass($className+'-'+ifile);
        $(this).hide().after(inputfileHTML);
        ifile++;
    });

    $('.styled-input-file').on('click', function(){
        var inputIndex = $(this).data('input-index');
        $('.'+$className+'-'+inputIndex).click();
    });

    $('.'+$className).on('change', function(){
        var inputIndex = $(this).data('input-index');
        $('.sif-'+inputIndex+' .text').text(this.files[0].name).attr('title', this.files[0].name);
    });
}



if($(".webform-submission-ouvrir-un-magasin-form, .webform-submission-newsletter-form").length > 0){
    var selectfields = $(".webform-submission-ouvrir-un-magasin-form, .webform-submission-newsletter-form").find('.form-type-textfield, .form-type-email, .form-type-tel, .form-type-textarea, .form-type-managed-file, .form-type-select').find('input, textarea, select');
    selectfields.each(function(){
        if($(this).val() != ''){
            $(this).closest('.form-item').addClass('label-focus');
        }
    });

    /* @TODO fix this because is not working */
    $('.form-type-select .control-label').on('click', function(){
        $('.form-type-select .form-select option').click();
    });

    selectfields.on('focusin', function(){
        $(this).closest('.form-item').addClass('label-focus');
    });


    selectfields.on('focusout', function(){
        if($(this).val().length === 0){
            $(this).closest('.form-item').removeClass('label-focus');
        }
    });
}

// if($(".webform-submission-newsletter-form").length > 0){
//     var selectfieldFooter = $('.webform-submission-newsletter-form .form-type-email input');
//     selectfieldFooter.each(function(){
//         if($(this).val() != ''){
//             $(this).closest('.form-item').addClass('label-focus');
//         }
//     });
//     selectfieldFooter.on('focusin', function(){
//         $(this).closest('.form-item').addClass('label-focus');
//     });
//     selectfieldFooter.on('focusout', function(){
//         if($(this).val().length === 0){
//             $(this).closest('.form-item').removeClass('label-focus');
//         }
//     });
// }

$(".select-custom .dropdown .dropdown-menu li").on("click", function(){
    let valueLabel = $(this).text();
    let value = $(this).data('value');
    let hiddenClass = $(this).closest('.dropdown-menu').data('hidden-class');

    $(this).closest('.dropdown').find('.dropdown-label').text(valueLabel);
    $('.select-custom .hidden.' + hiddenClass).val(value);
});

$(".select-custom .dropdown .dropdown-menu li[selected]").each(function() {

    let valueLabel = $(this).text();
    let value = $(this).data('value');
    let hiddenClass = $(this).closest('.dropdown-menu').data('hidden-class');

    $(this).closest('.dropdown').find('.dropdown-label').text(valueLabel);
    $('.select-custom .hidden.' + hiddenClass).val(value);
})




if($('.bg-text').length > 0){
    $(window).on("scroll", function(){
        let runAnimPos = Math.abs($('.bg-text').offset().top/3);
        if($(window).scrollTop() > runAnimPos){
            if(!$('.bg-text').hasClass("animToTop")) {
                $('.bg-text').addClass("animToTop");
            }
        }else{
            if($('.bg-text').hasClass("animToTop")){
                $('.bg-text').removeClass("animToTop");
            }
        }
    });
}

if($('input[type="checkbox"]').length > 0){
    $('input[type="checkbox"]').each(function(){
        $(this).closest(".control-label").addClass("custom-checkbox");
        if ($('input.checkbox_check').prop('checked')) {
            $(this).wrap('<div class="input-checkbox checked"></div>');
        }else{
            $(this).wrap('<div class="input-checkbox"></div>');
        }
    });
    $('input[type="checkbox"]').on("change", function(){
       if($(this).prop('checked')){
           $(this).closest(".input-checkbox").addClass('checked');
       }else{
           $(this).closest(".input-checkbox").removeClass('checked');
       }
    });
}

// $(window).scroll(function(){
//     console.log("toto1");
//     // console.log($('.bg-text').scrollTop());
// });


if($('.isotope-grid').length > 0){

   let isotopeInit = () => {

       var $container = $('.isotope-grid');

       $container.imagesLoaded( () => {

           window.$grid = $container.isotope({
               // set itemSelector so .grid-sizer is not used in layout
               itemSelector: '.grid-item',
               percentPosition: true,
               masonry: {
                   // use element for option
                   // columnWidth: '.grid-sizer'
               }
           });
       });
   }
   isotopeInit()

}

if($("#jobs-list").length > 0){
    $("#jobs-list tbody tr.table-row").on("click", function(){
        let url = $(this).find("a").attr("href");
        window.location.replace(url);
    });
}


/* Clic sur une actu de la HP peu importe ou */
$(document).on("click", ".anews-item-small", function(){
  if ($(this).find("a").length > 0) {
    document.location.href = $(this).find("a").attr("href")
  }
});

// Affichage ou non de la popup des pages de contenu
$( document ).ready(function() {
  if ($("#page_content_popup").length > 0) {
    let popup_delay_data = $("#page_content_popup").data("delay") !== "" ? parseInt($("#page_content_popup").data("delay")) : 0;

    if (!isNaN(popup_delay_data)) {
      let popup_delay = popup_delay_data !== "" ? popup_delay_data : 1000;
      setTimeout(function(){
        $("#page_content_popup").modal("show");
      }, popup_delay);
    }
  }
});



// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/app.js